var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"needThisRefForSomeReason"},[[_c('div',{ref:"subTable"},[_c('div',[_c('div',_vm._l((_vm.messages),function(message,messageIndex){return _c('div',{key:messageIndex},[_vm._v(" "+_vm._s(message)+" ")])}),0)])])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }